// Capstone Project
// John, Isabel, Nick, Bobur

import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Stripe from "../../Stripe/server";
import Filter from "../../Calendar/Filter";
import APIURL from "../../../helper/environment";

const SingleSpace = (props) => {
  const navigate = useNavigate();
  const { spotNumber, spotDescription, spotPricing, spotSize, inUse, _id } =
    props.parkingSpace;

  async function deleteParkingSpace() {
    let url = `${APIURL}/parking-space/delete/` + _id;

    let myHeaders = new Headers();
    myHeaders.append("Authorization", props.token); // token in header is for authorization

    let requestOptions = {
      headers: myHeaders,
      method: "DELETE",
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log("SingelSpace Info", data);
      props.showAllLotsSpaces(); // refresh the table after it has been deleted
    } catch (error) {
      console.error(error.message);
    }
  }
  return (
    <tr>
      <td>{spotNumber}</td>
      <td>{spotDescription}</td>
      <td>{spotPricing}</td>
      <td>{spotSize}</td>
      <td>{inUse}</td>
      <td>
        <Button color="primary" onClick={() => navigate(`/edit/${_id}`)}>
          Edit
        </Button>
      </td>
      <td>
        <Button color="danger" onClick={deleteParkingSpace}>
          Delete
        </Button>
      </td>
      <td>
        <Stripe />
      </td>

      <td>
        {/* <Button color="warning" onClick={(<Filter/>)}>

        Reserve
      </Button> */}
      </td>
      {/* <Filter/> */}
    </tr>
  );
};

export default SingleSpace;
